var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2485 0.159937C10.9085 0.149937 10.3086 0.419957 10.3086 0.679957V24.25H10.3385V26.05C10.7085 26.76 11.9485 26.69 12.0785 25.89V24.25H12.0985V0.679957C12.0985 0.509957 11.5185 0.169937 11.2485 0.159937Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81909 4.36985C5.42909 4.41985 5.15914 4.70986 5.11914 5.00986L5.16919 22.8698C5.56919 23.4498 6.53912 23.3998 6.84912 22.7898L6.90918 5.13987C6.92918 4.67987 6.4192 4.28985 5.8092 4.36985H5.81909Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5097 11.37C21.5097 11.37 21.5198 11.37 21.5298 11.37V7.20998C21.3298 6.92998 20.9798 6.75996 20.5598 6.80996C20.0898 6.85996 19.7598 7.21998 19.7698 7.57998V10.9099L19.7898 17.71C20.1598 18.42 21.3998 18.35 21.5198 17.55L21.4997 11.3599L21.5097 11.37Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2793 4.36009C15.9693 4.39009 15.7193 4.59013 15.5593 4.78013L15.5293 22.8001C15.9293 23.4101 16.7392 23.4301 17.2092 22.8501V4.78013C16.9992 4.52013 16.6893 4.32009 16.2693 4.36009H16.2793Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03953 11.8299V7.66989C1.83953 7.38989 1.48944 7.21992 1.06944 7.26992C0.599435 7.31992 0.269518 7.67988 0.279518 8.03988V9.9999L0.299538 16.7999C0.669538 17.5099 1.90952 17.4399 2.02952 16.6399V11.8299H2.03953Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwave);
export default __webpack_public_path__ + "static/media/soundwave.76ef8ad7786ac1be21675e1640ba623a.svg";
export { ForwardRef as ReactComponent };